import { CategoryChartQueryFn, CategoryChartQueryParam } from "../categoryChart";
// import { queryEntities } from "../misc";
import _ from "lodash";
import { FigureHorStackBarKpiProvider } from "./categoryChartData.types";

import { fetchFigureHorStackBarKpiProviderChartData } from "./fetchFigureHorStackBarKpiProviderChartData";
import { WaterProvider } from "../misc";
import { getBaseValue, roundValue, Unit } from "../processors";

export const computeVolumeWaterSourcedChartData = (
    provider: WaterProvider,
    kpis: string[][],
    data: FigureHorStackBarKpiProvider
) => {
    const totalValue = data?.figure?.value;

    if (typeof totalValue !== "number") return data;

    const { unit: baseTotalUnit, value: baseTotalValue } = getBaseValue(totalValue, data?.figure?.unit);

    const includeImportedWater = provider?.includeImportedWater ?? false;

    const importedKpi = kpis?.find(d => d?.[2]?.toLowerCase()?.indexOf("imported") > -1);
    const importedWaterLabel = importedKpi?.[2];

    // adjust seawater and total based on whether imported water is included or not
    const adjustedBasedTotalValue = includeImportedWater
        ? baseTotalValue
        : _.sum(
              data?.graph?.data
                  ?.filter(d => d.label !== importedWaterLabel)
                  ?.map(d => getBaseValue(d.value ?? 0, data?.unit)?.value)
          );
    // if not include import, filter out imported water values
    if (data?.graph?.data != null) {
        data.graph.data = includeImportedWater
            ? data?.graph?.data
            : data?.graph?.data?.filter(d => d.label !== importedWaterLabel);
    }

    // update total value figure
    const { unit: figureUnit, value: figureUnitValue } = roundValue(adjustedBasedTotalValue, baseTotalUnit);
    data.figure.value = figureUnitValue;
    data.figure.unit = figureUnit as Unit;

    return data;
};

export const fetchFigureHorStackBarVolumeWaterSourcedChartData: CategoryChartQueryFn = async ({
    categoryChart,
    providers,
    kpis,
    category,
    ...rest
}: CategoryChartQueryParam): Promise<FigureHorStackBarKpiProvider> => {
    const provider = providers?.[0];
    if (!provider || !categoryChart || kpis == null || !kpis?.length) return null;

    const data = (await fetchFigureHorStackBarKpiProviderChartData({
        categoryChart,
        providers,
        kpis,
        category,
        ...rest
    })) as FigureHorStackBarKpiProvider;

    return computeVolumeWaterSourcedChartData(provider, kpis, data);
};
